import "./index.css";
import { useState, useEffect } from "react";
import { Select, notification } from "antd";
import { useAuth } from "../../context/auth";

const PartyDropdown = ({ setSelectedPartys, ...props }) => {
  const { accessToken } = useAuth();

  const [partys, setPartys] = useState([]);
  useEffect(() => {
    async function getPartys() {
      const url = new URL('/api/party', window.location);
      url.searchParams.append('mode', 'dropdown');

      const res = await fetch(url, {
        headers: { 'X-ACCESS-TOKEN': accessToken },
      });
      if (res.ok) {
        const { partys } = await res.json();
        setPartys(partys);
      } else {
        notification["error"]({
          message: "Something went wrong !",
          description: `Please re-login or contact web admin. (Code: ${await res.json().then(data => data.message)})`,
        });
      }
    }

    getPartys();
  }, [accessToken]);

  return (
    <Select
      {...props}
      showSearch
      placeholder="Group Name"
      maxTagCount="responsive"
      maxTagPlaceholder={(ids) => `+ ${ids.length}`}
      optionFilterProp="children"
    >
      {setSelectedPartys && (
        <div disabled={true}>
          <span
            onClick={() => setSelectedPartys(partys.map(party => party.id))}
            style={{
              display: "inline-block",
              color: "#286FBE",
              cursor: "pointer",
            }}
          >
            SELECT ALL
          </span>
        </div>
      )}
      {partys.map(party => (
        <Select.Option key={party.id} value={party.id}>
          {party.nameEn}
        </Select.Option>
      ))}
    </Select>
  );
};

export default PartyDropdown;
